export { default as ThreeDStockContentSearchInImage } from './ThreeDStockContentSearchInImage';
